// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/tooltip/style/index.less
// module id = 1049
// module chunks = 1